<template>
  <div class="disclaimer-container">
    <p>
      Вся информация представлена справочно и не является договором оферты.
      Точную стоимость и характеристики можно уточнить в магазине.
    </p>
  </div>
</template>

<script>
export default {
  name: 'CatalogCategoryPriceDisclaimer',
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .disclaimer-container {
    margin-top: 1em;
    font-family: 'Baskerville Italic', $font-stack;

    .wf-baskervilleitalic-n4-active & {
      font-size: 1.25em;
    }
    & > p {
      margin: 0 2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/CatalogCategoryPriceDisclaimer.vue